import { Chip } from "@mui/material";

import theme from "@theme/index";

/**
 * @param isActive - Should the chip be highlighted/emphasized?
 */
export default function NewChip({ isActive }: { isActive: boolean }) {
  const chipStyles = {
    backgroundColor: isActive ? theme.palette.primary.main : theme.palette.grey[300],
    color: isActive ? "white" : theme.palette.grey[800],
    cursor: "pointer",
    fontWeight: "700",
    marginLeft: 1,
  };

  return <Chip label="New" size="small" sx={chipStyles} />;
}
